import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React from "react";
import ProgressiveImage from "react-progressive-image";
import { useNavigate } from "react-router-dom";
import blogDefaultImg from "../../../assets/images/defaultImages/imageUpload-img.jpg";
import itemInfoStyles from "../../../assets/styles/components/itemInfoStyles";
import BreadCrumps from "../../../components/BreadCrups";
import Tag from "../../../components/tag";
import { Markup } from "interweave";
import SingleItemMenu from "../../../components/Menu/SingleItemMenu";
import NoContent from "../../../components/NoContent";

const styles = makeStyles((theme) => itemInfoStyles(theme));

export default (props) => {
  const { blog, crumps } = props;
  const navigate = useNavigate();
  const classes = styles();

  const goToPage = (url) => navigate(url);

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {blog.title ? (
        <>
          <Grid container className={classes.topSection}>
            <Grid item xs={12} container justify="flex-start">
              <div>
                <ProgressiveImage
                  src={blog.imageUrl}
                  placeholder={props.placeholder || blogDefaultImg}
                >
                  {(src, loading) => (
                    <img
                      style={{
                        opacity: loading ? 0.7 : 1,
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                      src={src}
                      alt="No cover"
                      className={classes.image}
                    />
                  )}
                </ProgressiveImage>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              container
              direction="column"
              spacing={2}
              className={classes.infoSection}
            >
              <Grid item className={classes.textInfo}>
                <Grid item className={classes.actions}>
                  <Grid container spacing={2} justify="flex-end">
                    <SingleItemMenu
                      horiz
                      background
                      menu={props.actions}
                      item={blog}
                    />
                  </Grid>
                </Grid>

                <Tooltip title="Author" placement="right-end" arrow>
                  <Typography
                    variant="h6"
                    className={classes.name}
                    // onClick={() => goToPage(`/authors/${blog.authorEmail}`)}
                  >
                    Author: {blog.author?.name || blog.author?.id || "Unknown"}
                  </Typography>
                </Tooltip>
                <Typography variant="body1" className={classes.texts}>
                  Created: {moment(blog.createdAt).fromNow()}
                </Typography>
                <Typography variant="body1" className={classes.texts}>
                  Status: {blog.status}
                </Typography>
                <br />
                <span>
                  {blog.tags
                    ? blog.tags.map((elt) => <Tag key={elt} content={elt} />)
                    : null}
                </span>
              </Grid>
            </Grid>
          </Grid>

          <Grid container className={classes.otherSections} direction="column">
            <Grid item>
              <Typography variant="h5" className={classes.title}>
                Title: {blog.title}
              </Typography>
            </Grid>
            <br />
            <Grid item>
              <Typography variant="h5" className={classes.title}>
                Summary
              </Typography>
            </Grid>

            <Grid
              item
              style={{
                width: "100%",
                wordWrap: "break-word",
              }}
            >
              <Typography variant="subtitle1">{blog.summary}</Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.otherSections} direction="column">
            <div className={classes.title}>
              <Typography variant="h5" className={classes.title}>
                Content
              </Typography>
            </div>

            <div className={classes.title}>
              <Markup content={blog.content} />
            </div>
          </Grid>
        </>
      ) : (
        <NoContent title="Unable to find blog" />
      )}
    </div>
  );
};
